import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { URLsConfig } from '../URLsConfig';
import { UsersModel } from '../models/UsersModel';

@Injectable()
export class UsersService {
    constructor(private http: HttpClient, public urlsconfig: URLsConfig) {
    }
    public getusers(userID: string , comCode: string) {
      let params = new HttpParams();
        params = params.append("userID", userID);
        params = params.append("compCode", comCode);
        const options = {
            params: params
        };
        return this.http.get<UsersModel>(this.urlsconfig.WebAPIURL_Test + 'api/Users/Getusers',options);
    }
    public Addusers(users: UsersModel) {
        return this.http.post<UsersModel>(this.urlsconfig.WebAPIURL_Test + 'api/Users/Addusers', users);
    }
    public AddusersPic(users: UsersModel) {
      return this.http.post<UsersModel>(this.urlsconfig.WebAPIURL_Test + 'api/Users/AddUsersImags', users);
  }
  public getusersPic(userID: string , comCode: string) {
    let params = new HttpParams();
      params = params.append("userID", userID);
      params = params.append("compCode", comCode);
      const options = {
          params: params
      };
      return this.http.get<UsersModel>(this.urlsconfig.WebAPIURL_Test + 'api/Users/GetusersImag',options);
  }
  public getDefultPic(userID: string , comCode: string) {
    let params = new HttpParams();
      params = params.append("userID", 'evan');
      params = params.append("compCode", comCode);
      const options = {
          params: params
      };
      return this.http.get<UsersModel>(this.urlsconfig.WebAPIURL_Test + 'api/Users/GetusersImag',options);
  }

    public delusers(userID: string , compCode: string) {

      let params = new HttpParams();
        params = params.append("userID", userID);
        params = params.append("compCode", compCode);
        const options = {
          params: params
      };
      return this.http.get<UsersModel>(this.urlsconfig.WebAPIURL_Test + 'api/Users/Deleteusers',options);
    }
    public getusersLookup(userID: string, userName: string, compCode: string) {
      let params = new HttpParams();
      params = params.append("userID", userID);
      params = params.append("userName", userName);
      params = params.append("compCode", compCode);
      const options = {
          params: params
      };
      return this.http.get<UsersModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/Users/UsersLookup', options);
  }

    public getusersLookupTop(compCode: string) {
      let params = new HttpParams();
      params = params.append("compCode", compCode);
      const options = {
          params: params
      };
      return this.http.get<UsersModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/Users/UsersLookupTop', options);
  }
//////////******************************************* */
  public Usercahngpassword(user: UsersModel) {

    return this.http.post<UsersModel>(this.urlsconfig.WebAPIURL_Test + 'api/Users/ChangeUserPasswordAll', user);
  }
  public CheckUser(userID : string,password: string) {
    let params = new HttpParams();
    params = params.append("password", password);
    params = params.append("userID", userID);

    const options = {
      params: params
    };
    return this.http.get<UsersModel>(this.urlsconfig.WebAPIURL_Test + 'api/Users/CheckUser', options);
  }
  public Changepass(userID: string, password: string) {

    let params = new HttpParams();

    params = params.append("UserID", userID);
    params = params.append("password", password);


    const options = {
      params: params
    };
    return this.http.post<UsersModel>(this.urlsconfig.WebAPIURL_Test + 'api/Users/ChangeUserPassword', options);
  }

}
